import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import SEO from '../../SEO';
import { useAuth, isAdminUser, getDashboardPath } from '../../../context/AuthContext';
import DashboardLayout from '../shared/DashboardLayout';
import { AdminProvider } from './AdminContext';
import { ADMIN_NAV, getAdminNav } from './nav';

function AdminShell() {
  const { user, logout, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !user) navigate('/login');
    if (user && !isAdminUser(user)) {
      navigate(getDashboardPath(user));
    }
  }, [user, authLoading, navigate]);

  if (authLoading || !user) return null;

  const navItems = getAdminNav ? getAdminNav(user) : ADMIN_NAV;

  return (
    <>
      <SEO title="Admin Dashboard" description="InnovHer accelerator management system." />
      <DashboardLayout
        brand="Innovher"
        subtitle="Accelerator Management"
        navItems={navItems}
        user={{ ...user, name: user.fullName || user.name }}
        onLogout={() => {
          logout();
          navigate('/login');
        }}
      >
        <Outlet />
      </DashboardLayout>
    </>
  );
}

export default function AdminLayout() {
  return (
    <AdminProvider>
      <AdminShell />
    </AdminProvider>
  );
}
